let Api = {
	"TRADE_W_PRODUCT_PLATFINDPAGELIST": "/trade/w/product/platFindPageList", //分页查询商品列表
	"TRADE_N_PRODUCT_PLATFINDPAGELIST": "/trade/n/ShopHome/platFindPageList", //分页查询商品列表
	"TRADE_W_PRODUCT_FINDINFO": "/trade/w/product/findInfo", //查询商品详情
	"TRADE_W_COMMSALECATG_LIST": "/trade/w/CommSaleCatg/list", //获取商品销售分类列表
	"TRADE_W_PRODUCT_EXPORTPRODUCT": "/trade/w/product/exportProduct", //分页查询商品列表导出

	
}
module.exports = Api